import { useTranslation } from '../../i18n';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/AthleteSecurity.css';
import API_BASE_URL from '../../config/api';

const AthleteSecurity = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handlePasswordChange = async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      setMessage(t('athleteProfile.messages.userIdNotFound'));
      return;
    }
    if (!password || !confirmPassword) {
      setMessage(t('changePassword.mismatch'));
      return;
    }
    if (password !== confirmPassword) {
      setMessage(t('changePassword.mismatch'));
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/auth/change-password`, {
        userId,
        currentPassword: password,
        newPassword: confirmPassword
      });
      setMessage(t('changePassword.success'));
      setPassword('');
      setConfirmPassword('');
      setTimeout(() => navigate('/athlete-settings'), 2000);
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      setMessage(t('changePassword.error'));
    }
  };

  return (
    <div className="athlete-profile-container">
      <section className="profile-card" style={{ maxWidth: '480px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center' }}>{t('changePassword.title')}</h2>
        <input
          type="password"
          placeholder={t('common.currentPassword')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="security-input"
        />
        <input
          type="password"
          placeholder={t('common.newPassword')}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="security-input"
        />
        <button
          className="btn-change-password"
          onClick={handlePasswordChange}
          disabled={!password || !confirmPassword || password !== confirmPassword}
        >
          {t('changePassword.submit')}
        </button>
        {message && (
          <p
            className={`message ${message.includes('✅') ? 'success' : 'error'}`}
            style={{ textAlign: 'center', marginTop: '12px' }}
          >
            {message}
          </p>
        )}
      </section>
    </div>
  );
};

export default AthleteSecurity;
